var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSummarizeDocsIllustration = function SvgSummarizeDocsIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 324 250"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SummarizeDocsIllustration_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#SummarizeDocsIllustration_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 220,
    x: 21.957,
    y: 8.51,
    fill: "url(#SummarizeDocsIllustration_svg__c)",
    rx: 1.737,
    shapeRendering: "crispEdges",
    transform: "rotate(3 21.957 8.51)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 219,
    x: 16.5,
    y: 15.5,
    fill: "url(#SummarizeDocsIllustration_svg__d)",
    fillOpacity: 0.56,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 219,
    x: 16.5,
    y: 15.5,
    stroke: "url(#SummarizeDocsIllustration_svg__e)",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 4,
    x: 40,
    y: 39,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 4,
    x: 40,
    y: 47,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 4,
    x: 40,
    y: 66,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    x: 40,
    y: 74,
    fill: "#6B819C",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 2,
    x: 68,
    y: 74,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    x: 40,
    y: 79,
    fill: "#6B819C",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 2,
    x: 76,
    y: 79,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 40,
    y: 84,
    fill: "#6B819C",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 2,
    x: 60,
    y: 84,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 4,
    x: 40,
    y: 98,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 40,
    y: 106,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    x: 40,
    y: 113,
    fill: "#6B819C",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 2,
    x: 68,
    y: 113,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 2,
    x: 40,
    y: 118,
    fill: "#6B819C",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 2,
    x: 84,
    y: 118,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 40,
    y: 123,
    fill: "#6B819C",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 2,
    x: 60,
    y: 123,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 2,
    x: 40,
    y: 132,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    x: 40,
    y: 139,
    fill: "#6B819C",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 2,
    x: 76,
    y: 139,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    x: 40,
    y: 144,
    fill: "#6B819C",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 2,
    x: 68,
    y: 144,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    x: 40,
    y: 153,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    x: 40,
    y: 160,
    fill: "#6B819C",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 2,
    x: 68,
    y: 160,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 2,
    x: 40,
    y: 165,
    fill: "#6B819C",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 2,
    x: 88,
    y: 165,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    x: 40,
    y: 170,
    fill: "#6B819C",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 2,
    x: 76,
    y: 170,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 4,
    x: 40,
    y: 184,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 40,
    y: 192,
    fill: "#6B819C",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 2,
    x: 60,
    y: 192,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 2,
    x: 40,
    y: 197,
    fill: "#6B819C",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 2,
    x: 92,
    y: 197,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 2,
    x: 40,
    y: 202,
    fill: "#6B819C",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 2,
    x: 84,
    y: 202,
    fill: "#516B89",
    rx: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SummarizeDocsIllustration_svg__c",
    x1: 27.962,
    x2: 150.169,
    y1: 12.861,
    y2: 298.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111827",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SummarizeDocsIllustration_svg__d",
    x1: 19.681,
    x2: 150.959,
    y1: 16.212,
    y2: 306.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#385677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SummarizeDocsIllustration_svg__e",
    x1: 275,
    x2: 209.219,
    y1: 235,
    y2: 71.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#516B89",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SummarizeDocsIllustration_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h324v250H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "SummarizeDocsIllustration_svg__b",
    width: 448.99,
    height: 380.857,
    x: -62.495,
    y: -64.429,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 8.683,
    result: "effect1_dropShadow_7_3960"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.815,
    dy: 10.42
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.645
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00392157 0 0 0 0 0.0431373 0 0 0 0 0.145098 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_3960"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7_3960",
    result: "shape"
  })))));
};
export default SvgSummarizeDocsIllustration;